import React from "react";
import { Fab, Tooltip, Zoom, Box, Typography } from "@material-ui/core";
import PlayCircleOutlineIcon from "@material-ui/icons/PlayCircleOutline";
import { withTranslation } from "react-i18next";

const FloatingVideoLink = ({ t, role, i18n }) => {
  const userLanguage = i18n.language;
  const isFr = userLanguage.startsWith("fr");

  return (
    <>
      {role === "NO_SUBSCRIBTION" ||
        (role === "NEW_MEMBER" && (
          <Box
            sx={{
              position: "fixed",
              bottom: 20,
              right: 20,
              zIndex: 1000,
            }}
            style={{ color: "white" }}
          >
            <Tooltip
              title={t("demo_video.tooltip")}
              TransitionComponent={Zoom}
              arrow
              placement="left"
            >
              <Fab
                variant="extended"
                href={
                  isFr
                    ? "https://www.youtube.com/watch?v=wXnhoDOi_qQ"
                    : "https://www.youtube.com/watch?v=XX3L5TACDrQ"
                }
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  backgroundColor: "#F48A21",
                }}
                sx={{
                  bgcolor: "#F48A21",
                  color: "white",
                  "&:hover": {
                    bgcolor: "primary.dark",
                  },
                }}
              >
                <PlayCircleOutlineIcon
                  sx={{ mr: 1 }}
                  style={{ color: "white" }}
                />
                <Typography
                  style={{
                    color: "white",
                    textTransform: "none",
                    marginLeft: 6,
                  }}
                >
                  {t("demo_video.text")}
                </Typography>
              </Fab>
            </Tooltip>
          </Box>
        ))}
    </>
  );
};

export default withTranslation()(FloatingVideoLink);
